module.exports = __webpack_public_path__ + "static/media/img_13.864be123.png";